import { keyById } from '@Ravnur-Inc/nanoutils/keyBy';

import { LiveChannel$Privacy, LiveChannel$Indexing } from '../types/Live';

import { FieldDescription$ThesaurusDescription } from '@/types/FieldDescription';

export const PRIVACIES: FieldDescription$ThesaurusDescription = [
  { id: LiveChannel$Privacy.PUBLIC, tkey: 'privacy__public' },
  { id: LiveChannel$Privacy.UNLISTED, tkey: 'privacy__unlisted' },
  { id: LiveChannel$Privacy.RESTRICTED, tkey: 'privacy__restricted' },
];

export const PRIVACIES_AS_CACHE = keyById(PRIVACIES);

export const QAS: FieldDescription$ThesaurusDescription = [
  { id: 'true', tkey: 'qa__yes' },
  { id: 'false', tkey: 'qa__no' },
];

export const QAS_AS_CACHE = keyById(QAS);

export const INDEXINGS: FieldDescription$ThesaurusDescription = [
  { id: LiveChannel$Indexing.NONE, tkey: 'indexing__none' },
  { id: LiveChannel$Indexing.AUDIO, tkey: 'indexing__audio' },
  { id: LiveChannel$Indexing.ALL, tkey: 'indexing__all' },
];
